<p>
  entity-stats works!
</p>
